import React from 'react';
import MustHaveProduct from 'components/Tvendo/Article/Operations/MustHaveProduct/List';

export default function () {
  return <MustHaveProduct />;
}
